/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire, setGeneratePremiumSchedule }) {
  questionnaire = questionnaire.map((question) => {
    if (question.idQuestion === 1947 && question.idAnswerOption === 7602) {
      setGeneratePremiumSchedule(true)
    }

    return question;
  })

  return questionnaire;
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setGeneratePremiumSchedule,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1947) {
      saveQuestionnaire = true;

      const showAttachments = value.idAnswerOption === 7601;

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if ([1979].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption !== 7602;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {
            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }
        }

        return qst;
      })

      setGeneratePremiumSchedule(!showAttachments);
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('PREMIUM_SCHEDULE_ATTACHMENTS - handleQuestionChange - error', e);
  }
}


const events = {
  handleInitialAdjustments,
  handleQuestionChange
};

export { events };